export const getSelectInputValue = ({ value }) => (value.label || value.customBondName
    ? { ...value, label: value.customBondName || value.label }
    : null
);
